import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonUtility, ServerConstantsService, DataService, Components, DateUtility } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-service-provider',
  templateUrl: './service-provider.component.html',
  styleUrls: ['./service-provider.component.scss']
})
export class ServiceProviderComponent implements OnInit, CanComponentDeactivate {

  today: Date = new Date();
  serverConstants;
  serviceProvider;
  userActionNotificationsMap: any;
  sharedData;
  minEndDate:NgbDateStruct;
  maxStartDate: NgbDateStruct;
  isChangeDetected: boolean;

  constructor(private route: Router,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,

    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();

  }

  ngOnInit() {
    this.dataService.globalAccess = true;
    if(this.dataService.globalAccess == undefined){
      this.router.navigate(['/task']);
    }
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);
    this.serviceProvider = new ServiceProvider('', '', '', this.dateUtil.getFormattedSystemDateFromModel);
    this.maxStartDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    }
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
   
  };

  
  save() {
    this.isChangeDetected = false;
    this.serviceProvider.serviceProviderBeginDt = this.dateUtil.convertDateForServer(this.serviceProvider.serviceProviderBeginDt);

    this.serviceProvider.serviceProviderEndDt = this.dateUtil.convertDateForServer(this.serviceProvider.serviceProviderEndDt);


    this.http.post<ServiceProvider>(this.serverConstants.SERVER_API_URL + '/component/save-sevice-provider', this.serviceProvider)
      .subscribe(
        (res: ServiceProvider) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Add Service Provider', this.userActionNotificationsMap.ERROR);
          } else {
            this.notificationService.success('Add Service Provider', this.userActionNotificationsMap.ADD);
           
              this.dataService.addValueToSharedDataMap("NewServerProvider",res.serviceProviderName);
            
            this.router.navigate(['task/componentSummary/componentDetails']);

          }
        },
        (response) => {
          this.notificationService.error('Add Service Provider', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }
  cancel() {
    this.router.navigate(['task/componentSummary/componentDetails']);
  }

  startDateValidation() {
    // const serviceProviderBeginDt =  this.serviceProvider.serviceProviderBeginDt;
    // const startPlusOne=this.dateUtil.addDays(this.dateUtil.convertDateForServer(serviceProviderBeginDt),1);
    // this.minEndDate={
    //   month: startPlusOne.getMonth() + 1,
    //   day: startPlusOne.getDate() ,
    //   year: startPlusOne.getFullYear()
    // };
    this.minEndDate = {
      month: this.serviceProvider.serviceProviderBeginDt["month"],
      day: this.serviceProvider.serviceProviderBeginDt["day"],
      year: this.serviceProvider.serviceProviderBeginDt["year"]
    }
  }

  restrictSpaceSpecial(event){
    if(!((event.shiftKey === false) && (event.keyCode >= 48) && (event.keyCode <= 57) || (event.keyCode >= 65) && (event.keyCode <= 90) ||(event.keyCode == 222) || (event.keyCode == 189) || (event.keyCode == 9) ||  (event.keyCode>=37) && (event.keyCode<=40) || (event.keyCode ==8))){
      event.returnValue = false;
      return;
   }
   if(event.key==='"' || event.key==='_')
   {
    event.returnValue = false;
   }else{
    event.returnValue = true;
   }
   
  }

  restrictSpecial(event){
    if((/[<>{}]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }

}

export class ServiceProvider {
  constructor(

    public serviceProviderName: string,
    public contactFirstName: string,
    public contactLastName: string,
    public serviceProviderBeginDt: any,
    public serviceProviderEndDt?: any,
    public id?: number,
  ) {
  }
}





// WEBPACK FOOTER //
// ./src/app/service-provider/service-provider.component.ts